<template>
  <Base icon="mdi-decagram" :satisfied="requirement.satisfied" tooltip>
    <span>
      {{ display }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }} have an aggregate of
      {{ requirement.negative ? 'less than' : 'at least' }}
      {{ display }}
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
  computed: {
    display() {
      switch (this.requirement.grade.scale) {
        case 'Ugandan 5-point GPA':
          return `${this.requirement.grade.value} CGPA`
        case 'Percentage':
          return `${this.requirement.grade.value} %`
        case '4-point GPA':
          return `${this.requirement.grade.value} GPA`
        case '5-point GPA':
          return `${this.requirement.grade.value} GPA`
        case '6-point GPA':
          return `${this.requirement.grade.value} GPA`
        case '7-point GPA':
          return `${this.requirement.grade.value} GPA`
        case 'Percentage':
          return `${this.requirement.grade.value} %`
        default:
          return this.requirement.grade.value
      }
    },
  },
}
</script>
